export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';
export const UNSET_USER = 'UNSET_USER';

export const STUDENT = 'STUDENT';
export const CUSTOMER = 'CUSTOMER';
export const EMPLOYEE = 'EMPLOYEE';



// WEBPACK FOOTER //
// ./src/infrastructure/auth/store/_types.js